export type SearchParamValue = string | number | boolean | null | undefined;

export interface WriteSearchParamOptions {
  deleteWhenEmpty?: boolean;
}

export function writeSearchParam(
  params: URLSearchParams,
  key: string,
  value: SearchParamValue,
  options: WriteSearchParamOptions = {},
) {
  if (
    value === null ||
    value === undefined ||
    (options.deleteWhenEmpty !== false && value === '')
  ) {
    params.delete(key);
    return params;
  }

  params.set(key, String(value));
  return params;
}

export function replaceSearchParam(
  currentParams: URLSearchParams,
  key: string,
  value: SearchParamValue,
  options?: WriteSearchParamOptions,
) {
  return writeSearchParam(
    new URLSearchParams(currentParams),
    key,
    value,
    options,
  );
}

export function writeSearchParams(
  params: URLSearchParams,
  values: Readonly<Record<string, SearchParamValue>>,
  options?: WriteSearchParamOptions,
) {
  for (const [key, value] of Object.entries(values)) {
    writeSearchParam(params, key, value, options);
  }

  return params;
}

export function replaceSearchParams(
  currentParams: URLSearchParams,
  values: Readonly<Record<string, SearchParamValue>>,
  options?: WriteSearchParamOptions,
) {
  return writeSearchParams(new URLSearchParams(currentParams), values, options);
}
